import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getTenantInfoByKey, replaceExpecialCharacters } from '../../../helpers/helpers';
import { CustomSelectComplex } from '../../CustomSelectComplex/CustomSelectComplex';
import { Input, FormGroup, Spinner } from 'reactstrap';
import BuildingsManagementContext from '../../../context/BuildingManagementContext/BuildingsManagementContext';
import { ButtonBlue } from '../../Buttons/ButtonBlue';
import { CustomModal } from '../../CustomModal/CustomModal';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import OpenningManagementContext from '../../../context/OpenningsManagmentContext/OpenningManagementContext';
import buildingSuccessIcon from '../../../assets/icons/building-success-icon.svg';

export const CreateAndEditBuilding = () => {
  const navigate = useNavigate();
  const { buildingId } = useParams();
  const isAccessOpening = getTenantInfoByKey('is_access_opening');
  const isEditing = buildingId;

  const { buildingsManagementState, getBuilding, createBuilding, editBuilding } = useContext(BuildingsManagementContext);
  const { buildingData, buildingsToConfig, isFetching, responseBuildingService } = buildingsManagementState;

  const { openningManagementState, getOpennigsManagement } = useContext(OpenningManagementContext);
  const { openningsToConfig } = openningManagementState;

  const openingOptions = openningsToConfig.map(opening => ({ label: `${opening.code} - ${opening.description}`, value: opening.code, target: { value: opening.code, name: 'openingCode' } }));

  const [buildingDataState, setBuildingDataState] = useState(buildingData);

  const disabled = isAccessOpening ? (!buildingDataState.openingCode) || !!!String(buildingDataState.buildingCode).trim() || !!!String(buildingDataState.buildingDescription).trim() : !!!String(buildingDataState.buildingCode).trim() || !!!String(buildingDataState.buildingDescription).trim();

  const nameOfOpenings = getTenantInfoByKey('opening_name');
  const instanceHasOpenings = getTenantInfoByKey('is_access_opening');

  const handleChange = (e, selectName) => {

    if (selectName === 'openingCode' && e === null) {
      return setBuildingDataState({
        ...buildingDataState,
        'openingCode': null
      })
    }

    let { value, name, checked } = e.target;

    setBuildingDataState({
      ...buildingDataState,
      [name]: name === 'buildingEnabled' ? checked : replaceExpecialCharacters(value)
    })
  }

  const handleSubmit = async () => {
    if (disabled) return
    if (buildingId) {
      return await editBuilding(buildingDataState);
    }
    await createBuilding(buildingDataState);
  }

  const closeWarningModal = async () => navigate('/settings/entityManagment/buildingsMaganagement');

  const goCancel = () => navigate(-1);

  const getBuildingAndLoadData = async () => {
    const response = await getBuilding(buildingId);
    setBuildingDataState(response);
  }

  useEffect(() => {
    if (openningsToConfig.length === 0 && instanceHasOpenings) {
      getOpennigsManagement();
    }

    if (isEditing && buildingsToConfig.length === 0) {
      getBuildingAndLoadData()
    }
    // eslint-disable-next-line
  }, []);

  return (

    <div className='row justify-content-center'>
      <div className='col-xl-4 col-lg-7 col-sm-9 mt-5'>
        <div className='me-3 ms-3 mt-2'>

          <CustomModal showModal={responseBuildingService.show} centered={true} setShowModal={closeWarningModal}>
            <div className='d-flex flex-column align-items-center justify-content-center'>
              <img src={responseBuildingService.type === 'ERROR' ? errorIcon : buildingSuccessIcon} alt="" />
              <p className='mt-3 text-center param-section-title'>{responseBuildingService.text}</p>
              <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
            </div>
          </CustomModal>

          {isFetching ?
            <div className="d-flex mt-4 justify-content-center">
              <Spinner />
            </div>
            : null}

          <div>
            <p className='m-0 titlelabel-filter'>{t('CODE')}</p>
            <p>
              <input
                className='form-control'
                type="text"
                name='buildingCode'
                value={buildingDataState.buildingCode}
                onChange={handleChange}
                disabled={buildingId ? true : false}
              />
            </p>
          </div>

          <div>
            <label
              htmlFor="buildingDescription"
              className="titlelabel-filter"
            >
              {t('DESCRIPTION')}
            </label>
            <textarea
              className='form-control'
              name="buildingDescription"
              cols="30"
              rows="5"
              value={buildingDataState.buildingDescription}
              placeholder={t('ENTER_DESCRIPTION')}
              maxLength={255}
              onChange={handleChange}
            >
            </textarea>
          </div>

          {isAccessOpening ?
            <div className='mt-2'>
              <label
                className="form-label titlelabel-filter"
                htmlFor="contractors"
              >
                {nameOfOpenings}
              </label>

              <CustomSelectComplex
                options={openingOptions}
                value={openingOptions.find(options => options.value === buildingDataState.openingCode)}
                name={'openingCode'}
                placeholder={t('SELECT')}
                isClearable={true}
                onChange={(e) => handleChange(e, 'openingCode')}
              />
            </div>
            : null
          }
          <div className='mt-3'>
            <div style={{ backgroundColor: '#FFFFFF', borderRadius: '5px' }} className='p-2 d-flex justify-content-between align-items-center'>
              <div>
                <p className='m-0'>{buildingDataState.buildingEnabled ? t('ENABLED') : t('NOT_ENABLED')}</p>
              </div>

              <div>
                <FormGroup switch>
                  <Input type="switch" name='buildingEnabled' checked={buildingDataState.buildingEnabled} onClick={handleChange} />
                </FormGroup>
              </div>
            </div>


            <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
              <div className=''>
                <p type='button' className='m-0' onClick={goCancel}>{t('CANCEL')}</p>
              </div>

              <div className=''>
                <ButtonBlue onClick={handleSubmit} disabled={disabled}>
                  {t('SAVE')}
                </ButtonBlue>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
